const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Hej',
    'Ref: Page content body': 'Vid ankomst och avgång, var noga med att skanna din QR -kodbuss',
  },
};
export default labels;
